import 'edge/quoteandbind/common/app';
import 'angularRouter';
import 'gw-portals-bop-components-angular';
import './components/module';
import AppConfig from './config/AppConfig.js';

import LocationsAndBuildings from 'gw-portals-bop-components-angular/locationsAndBuildings';

import RouteConfig from './config/RouteConfig';

import CPPCoverablesService from '../cpp/services/CPPCoverablesService';
import CPPQuoteUtilService from '../cpp/services/CPPQuoteUtilService';
import CPPCreditScoreService from '../cpp/services/CPPCreditScoreService';
import CPPRequestCallbackService from '../cpp/services/CPPRequestCallbackService';
//AMA
import GLExposureDTO from './utils/GlExposureDTO';

export default angular.module('ama.edge.quoteandbind.cpp.app', ['edge.quoteandbind.common.app', 'edge.policyjob.app', 'gw-portals-bop-components-angular', 'ama-portals-cpp-components-angular']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).value('ama.AppConfig', new AppConfig()).service('ama.CPPQuoteUtilService', CPPQuoteUtilService).service('ama.CPPCreditScoreService', CPPCreditScoreService).service('ama.CPPRequestCallbackService', CPPRequestCallbackService).service('ama.CPPQuoteUtilService', CPPQuoteUtilService).factory('qnb.cppCoverablesService', CPPCoverablesService).value('ama.CppFlowConstants', {
    'ProductCode_AMA': 'CommercialPackage',
    'CPPGLCodes_AMA': []
}).component('gwLocationsAndBuildings', LocationsAndBuildings).run(['$state', '$rootScope', 'ExpressionLanguageService', 'googleTagManager', 'altocloudAnalytics', 'ama.AppConfig', function ($state, $rootScope, ExpressionLanguageService, googleTagManager, altocloudAnalytics, AMAConfig) {

    // This is important to reflect the state of the application on the HTML. Look at app/html/index.html
    $rootScope.$state = $state;

    //This just initializes googleTagManager adapter.
    googleTagManager;
    //console.log();
    altocloudAnalytics();

    ExpressionLanguageService.getCompilationContext('pc').registerType('ama.edge.capabilities.policyjob.lob.generalliability.coverables.dto.GlExposureDTO', GLExposureDTO);
}]);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=cpp!./app/customer/js/src/edge/quoteandbind/ama/cpp/app.js
// module id = 385
// module chunks = 0